import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_resume",
  "use": "icon-project_resume-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_resume\"><g transform=\"translate(1 3)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M10.517 23H3.52C1.576 23 0 21.502 0 19.655V3.345C0 1.498 1.576 0 3.52 0h14.96C20.424 0 22 1.498 22 3.345v4.038\" stroke-linecap=\"round\" /><circle cx=\"20\" cy=\"14\" r=\"3\" /><path d=\"M26 24a6 6 0 10-12 0M5 13.481h7M5 7.5h11\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol